export default "__VITE_ASSET__pKFDuizU__"